import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';

import Widget from 'elements/Widget';

import { getOutputText } from 'utils/widget';

import CaseServiceRequestInfoConainer from './CaseServiceRequestInfoConainer';
import ServReqServReqInfoContainer from './ServReqServReqInfoContainer';
import messages from './messages';

export function ServiceRequestInfoWidget({
  serviceRequestInfo: {
    reasonForRepair,
  },
}) {
  const { code, description } = reasonForRepair || {};
  const content = code && description && `${code} - ${description}`;

  return (
    <Widget id="service-request" expandKey="service-request">
      <Widget.Header>
        <Trans id={messages.title} />
      </Widget.Header>
      <Widget.Item>
        <Widget.Table>
          <tbody>
            <Widget.TableRow modifiers={['topGap']}>
              <th>
                <Trans id={messages.reasonForRepair} />
              </th>
              <td>
                {getOutputText(content)}
              </td>
            </Widget.TableRow>
          </tbody>
        </Widget.Table>
      </Widget.Item>
    </Widget>
  );
}

ServiceRequestInfoWidget.propTypes = {
  serviceRequestInfo: PropTypes.shape({
    reasonForRepair: PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
    }),
  }).isRequired,
};

export const CaseServiceRequestInfoWidget =
  CaseServiceRequestInfoConainer(ServiceRequestInfoWidget);
export const ServiceRequestServReqInfoWidget =
  ServReqServReqInfoContainer(ServiceRequestInfoWidget);



// WEBPACK FOOTER //
// ./compositions/ServiceRequestWidget/index.js